import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    title: 'Your inflammation disappears',
    desc: '(Goodbye, bloating)'
  }, {
    title: 'Your deep sleep returns',
    desc: '(Goodbye, 2 AM racing thoughts)'
  }, {
    title: "Your metabolism finally 'unlocks'",
    desc: 'Using stored fat for energy'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-sage-400 text-white relative overflow-hidden" data-id="element-64">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-65"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-67">
          <h2 className="text-sm font-bold tracking-widest text-cream uppercase mb-4" data-id="element-68">
            The Revelation (The "New Way")
          </h2>
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold mb-8 leading-tight" data-id="element-69">
            I discovered that you can "flip the switch" from Stress Mode to
            Repair Mode in as little as 10 minutes.
          </h3>
          <p className="text-2xl font-display italic text-cream-dark mb-8" data-id="element-70">
            It's called Somatic Regulation.
          </p>
          <p className="text-lg max-w-2xl mx-auto text-cream" data-id="element-71">
            By using specific, science-backed micro-movements and biological
            "hacks," you can lower your cortisol levels on command.
          </p>
        </motion.div>

        <div className="bg-white text-charcoal-800 rounded-3xl p-8 sm:p-12 shadow-2xl max-w-3xl mx-auto" data-id="element-72">
          <h4 className="text-2xl font-bold mb-8 text-center" data-id="element-73">
            When cortisol drops:
          </h4>
          <div className="space-y-6" data-id="element-74">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex items-start gap-4" data-id="element-75">
                <CheckCircle2 className="w-8 h-8 text-sage-500 shrink-0 mt-1" data-id="element-76" />
                <div data-id="element-77">
                  <p className="text-xl font-bold" data-id="element-78">{benefit.title}</p>
                  <p className="text-charcoal-700/70 italic" data-id="element-79">{benefit.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}